// Memory — the journaled decision record (real /journal) + Latest Thoughts (real).
import React, { useMemo } from "react";
import { useBrainResource } from "../lib/hooks";
import { ResourceGate, EmptyState } from "../BrainStates";
import LatestThoughts from "../panels/LatestThoughts";
import { selectLatestThoughts } from "../lib/selectors";

function list(r, key) { const x = r && r.status === "ok" ? r.data : null; return x ? x[key] || (Array.isArray(x) ? x : []) : []; }

export default function MemoryScreen() {
  const journal = useBrainResource("/journal");
  const outcomes = useBrainResource("/outcomes");
  const evaluations = useBrainResource("/evaluations");
  const observations = useBrainResource("/intelligence/observations");
  const thoughts = useMemo(() => selectLatestThoughts({ outcomes: list(outcomes, "outcomes"), evaluations: list(evaluations, "evaluations"), observations: list(observations, "observations") }), [outcomes.data, evaluations.data, observations.data]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="memory-screen" className="space-y-5">
      <h1 className="text-2xl font-extrabold tracking-tight text-white">Memory</h1>
      <div className="grid gap-5 lg:grid-cols-2">
        <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
          <h2 className="mb-3 text-sm font-semibold text-slate-200">Decision journal</h2>
          <ResourceGate resource={journal} capability="Executive Journal" flag="EXECUTIVE_JOURNAL_ENABLED" empty={<EmptyState title="No journal entries" testId="journal-empty" />}>
            {(data) => {
              const entries = data.entries || [];
              if (entries.length === 0) return <EmptyState title="No journal entries" testId="journal-empty" />;
              return (
                <ul className="space-y-2">
                  {entries.map((e) => (
                    <li key={e.entry_id} className="rounded-md bg-slate-800/40 p-2" data-testid="journal-row">
                      <p className="text-sm text-slate-200">{e.decision_type || "decision"}</p>
                      <p className="text-[11px] text-slate-500">{e.business_unit} · {e.disposition || e.status_at_creation} · {e.created_at}</p>
                    </li>
                  ))}
                </ul>
              );
            }}
          </ResourceGate>
        </div>
        <LatestThoughts thoughts={thoughts} />
      </div>
    </div>
  );
}
